import { Radio, RadioGroup, Stack } from "@chakra-ui/react";
import axios from "axios";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { NotificationManager } from "react-notifications";
import { useNavigate, useParams } from "react-router-dom";
import { ROUTES } from "../../../routes/routeKeys";
import Select from "react-select";
import dollor from "../../../assets/icons/dollar.svg";
import percentage from "../../../assets/icons/percentage.svg";
import SearchDropdown from "../../../components/Dropdowns/SearchDropdown";
import InputWithIcon from "../../../components/InputWithIcon";
import useAuth from "../../../hooks/useAuth";
import { BASE_URL } from "../../../utils/Element";
import { landlordOptions } from "../../../utils/options";


const AddExclusiveData = ({ showModal, formData,search, disable, error, onSetFormData, onSetError, handleSubmit, handleClose }) => {
  const [config] = useAuth();
  const { id } = useParams();
  const navigate = useNavigate();
  const [listOptions, setListOptions] = useState([]);
  const [propertyOptions, setPropertyOptions] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
    


  const handleChange = (value, name) => {
    onSetError({ ...error, [name]: "" });
    onSetFormData({ ...formData, [name]: value });
  };

  const handleClientTypeChange = (value) => {
    onSetError({ ...error, client_type: "" });
    onSetFormData({ ...formData, client_type: value, client_id: "", client_name: "", property_id: "" });
  };

  const fetchSuggestions = (inputValue) => {
    if (inputValue !== "") {
      axios
        .get(`${BASE_URL}/get-datalisting?list=${formData?.client_type === "contact" ? "contacts" : "companies"}&search=${inputValue}`, config)
        .then((res) => {
          const data = res?.data?.data;
          const contactOptions = data?.contact_list?.map((el) => ({ value: el?.id, label: `${el?.first_name} ${el?.last_name}` }));
          const companyOptions = data?.company_list?.map((el) => ({ value: el?.id, label: el?.company_name }));
          const options = formData?.client_type === "contact" ? contactOptions : companyOptions;
          setListOptions(options);
        })
        .catch((err) => {
          if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
            NotificationManager.error(err.response?.data?.message);
          }
        });
    } else {
      setListOptions([]);
    }
  };

  const handlePortfolioChange = (value) => {
    const portfolioStatus = formData.portfolio? 0 :1;
    onSetFormData({ ...formData, portfolio: portfolioStatus, property_id: "" });
  };

  const fetchProperties = () => {
    const url = formData?.client_type === "contact" ? `get-ContactData/${formData?.client_id}` : `get-property/${formData?.client_id}`;
    axios
      .get(`${BASE_URL}/${url}`, config)
      .then((res) => {
        
        if (formData?.client_type === "contact") {
          const data = res?.data?.data;
          const properties = data?.properties;
          const portfolios = data?.portfolios;
          const propertyOptions = properties?.map((el) => ({ value: el?.id, label: el?.property_name, desc: `${el.street_address}, ${el.city}, ${el.state}` }));
          const portfolioOptions = portfolios?.map((el) => ({ value: el?.id, label: el?.name, desc: `` }));
          if (formData.portfolio === 1) {
            setPropertyOptions(portfolioOptions);
          } else{
            setPropertyOptions(propertyOptions);
          }
        } else {
          const data = res?.data?.property;
          const propertyOptions = data?.map((el) => ({ value: el?.id, label: el?.property_name, desc: `${el.street_address}, ${el.city}, ${el.state}` }));
          setPropertyOptions(propertyOptions);
        }
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  const fetchSearchResults = () => {
    // if (typeof search === 'string' && search.trim() !== "") {
      const endpoint = `${BASE_URL}/get-datalisting?list=contacts&search=${search}&company_id=${formData?.client_id}`;
      axios
        .get(endpoint, config)
        .then((res) => {
          const contactcompanyOptions = res?.data?.data?.contact_list?.map((el) => ({ value: el?.id, label: `${el?.first_name} ${el?.last_name}` }));
           setSearchResults(contactcompanyOptions || []);
        })
        .catch((err) => {
          setSearchResults([]);
          if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
            NotificationManager.error(err.response?.data?.message);
          }
        })
        .finally(() => setLoading(false));
    // } else {
    //   setSearchResults([]);
    // }
  };
  

  useEffect(() => {
    if (showModal && formData?.client_id !== "") {
      fetchProperties();
      fetchSearchResults();
    }
  }, [showModal, formData?.client_type, formData?.client_id,formData.portfolio]);

  const formatOptionLabel = ({ value, label, minPrice, maxPrice, desc }) => (
    <div>
      <div>{label}</div>
      {desc && <p className="dark-M">{desc}</p>}
      {(minPrice || maxPrice) && (
        <div className="flex gap-2 dark-M">
          {minPrice && <div>Min Price-{minPrice}</div>}/{maxPrice && <div>Max Price-{maxPrice}</div>}
        </div>
      )}
    </div>
  );

  return (
    <form onSubmit={handleSubmit}>
    <RadioGroup
     onChange={(value) => {
       handleClientTypeChange(value);
       setListOptions([]);
     }}
     value={formData?.client_type}
   >
     <Stack direction="row" gap={5}>
       <Radio value="contact">Contact</Radio>
       <Radio value="company">Company</Radio>
     </Stack>
     </RadioGroup>

      <div className="mt-3 flex-1">
        <SearchDropdown
          isTop={false}
          placeholder={`search ${formData?.client_type} here`}
          text={formData?.client_name}
          options={listOptions}
          fetchSuggestions={fetchSuggestions}
          onSetOptions={(value) => setListOptions(value)}
          handleSelect={(option) => {
            onSetError({ ...error, client_id: "" });
            onSetFormData({ ...formData, client_name: option?.label, client_id: option?.value });
            setListOptions([]);
          }}
        />
        {error?.client_id && <span className="body-S red-D">{error?.client_id}</span>}
      </div>

      {formData?.client_id !== "" && (
        <>
          <div className="mt-6">
              <label className="container" style={{ marginBottom: "0px" }}>
                  <p style={{ paddingLeft: "30px" }}>Portfolio</p>
                  <input
                    type="checkbox"
                    checked={formData?.portfolio}
                    onChange={(value) => {
                      handlePortfolioChange(value);
                    }}
                  />
                  <span className="checkmark"></span>
                </label>
            </div>
          <div className="mt-6">
            <label className="dark-H head-4">
              Property Name
            </label>
            <div className="mt-1.5">
              <Select
                className="body-N"
                options={propertyOptions}
                formatOptionLabel={formatOptionLabel}
                placeholder={"Select property"}
                value={propertyOptions?.find((option) => option.value === formData?.property_id)}
                onChange={(option) => {
                  handleChange(option.value, "property_id");
                }}
              />
            </div>
      
            {propertyOptions.length === 0 && formData.client_id !== "" && (
              <p className="body-S red-D">
                No property found under this {formData?.client_type}.{" "}
                <span role="button" className="underline green-H" onClick={() => navigate(formData?.client_type === 'company' ? ROUTES.COMPANY_DETAILS.replace(":id", formData?.contact) : ROUTES.CONTACT_DETAILS.replace(":id", formData?.contact))}>
                  Click here to add
                </span>
              </p>
            )}
            {error?.client_id && <span className="body-S red-D">{error?.client_id}</span>}
          </div>
      
          {formData?.client_type === "company" && (
            <div className="mt-6">
              <label className="dark-H head-4">
                Contact
              </label>
              <div className="mt-1.5">
                <Select
                  className="body-N"
                  options={searchResults}
                  formatOptionLabel={formatOptionLabel}
                  placeholder={"Select contact"}
                  value={searchResults?.find((option) => option.value === formData?.contact_id)}
                  onChange={(option) => {
                    handleChange(option.value, "contact_id");
                  }}
                />
              </div>
      
              {searchResults.length === 0 && formData.client_id !== " " && (
                <p className="body-S red-D">
                  No contact found under this {formData?.client_type}.{" "}
                  <span role="button" className="underline green-H" onClick={() => navigate(formData?.client_type === 'company' ? ROUTES.COMPANY_DETAILS.replace(":id", formData?.contact) : ROUTES.CONTACT_DETAILS.replace(":id", formData?.contact))}>
                    Click here to add
                  </span>
                </p>
              )}
              {error?.client_id && <span className="body-S red-D">{error?.client_id}</span>}
            </div>
          )}
        </>
      )}


      <div className="mt-6">
        <label className="dark-H head-4 mb-2 required:*:">
          Initial List Date
        </label>
        <DatePicker
          className="body-N"
          dateFormat="MM/dd/yyyy"
          placeholderText="MM/DD/YYYY"
          maxDate={new Date()}
          selected={formData.initial_list_date}
          onChange={(date) => {
            handleChange(date, "initial_list_date");
          }}
        />
        {error?.initial_list_date && <span className="body-S red-D">{error?.initial_list_date}</span>}
      </div>

      <div className="mt-6">
        <label className="dark-H head-4 mb-2 required:*:">
          Current List Date
        </label>
        <DatePicker
          className="body-N"
          dateFormat="MM/dd/yyyy"
          placeholderText="MM/DD/YYYY"
          maxDate={new Date()}
          selected={formData.current_list_date}
          onChange={(date) => {
            handleChange(date, "current_list_date");
          }}
        />
        {error?.current_list_date && <span className="body-S red-D">{error?.current_list_date}</span>}
      </div>


      <div className="mt-6">
        <label className="dark-H head-4 mb-2 required:*:">
          Listing Expiration Date
        </label>
        <DatePicker
          className="body-N"
          dateFormat="MM/dd/yyyy"
          placeholderText="MM/DD/YYYY"
          minDate={new Date()}
          selected={formData.expiration_date}
          onChange={(date) => {
            handleChange(date, "expiration_date");
          }}
        />
        {error?.expiration_date && <span className="body-S red-D">{error?.expiration_date}</span>}
      </div>

      <div className="mt-6">
        <label className="dark-H head-4 mb-2 required:*:">
          Company Commission
        </label>
        <InputWithIcon
           icon={percentage}
          className="body-N"
          name="contact"
          type="number"
          placeholder="Write Here"
          value={formData?.brokerage_commission}
          onChange={(e) => {
            handleChange(e.target.value, "brokerage_commission");
          }}
          onWheel={(e) => e.target.blur()}
        />
        {error?.brokerage_commission && <span className="body-S red-D">{error?.brokerage_commission}</span>}
      </div>

      <div className="mt-6">
        <label className="dark-H head-4 mb-2 required:*:">
          NOI
        </label>
        <InputWithIcon
          icon={dollor}
          className="body-N"
          name="contact"
          type="number"
          placeholder="Write Here"
          value={formData?.anual_rent}
          onChange={(e) => {
            handleChange(e.target.value, "anual_rent");
          }}
          onWheel={(e) => e.target.blur()}
        />
        {error?.anual_rent && <span className="body-S red-D">{error?.anual_rent}</span>}
      </div>

      <div className="mt-6">
        <label className="dark-H head-4 mb-2 required:*:">
          Asking Price
        </label>
        <InputWithIcon
          icon={dollor}
          className="body-N"
          name="contact"
          type="number"
          placeholder="Write Here"
          value={formData?.asking_price}
          onChange={(e) => {
            handleChange(e.target.value, "asking_price");
          }}
          onWheel={(e) => e.target.blur()}
        />
        {error?.asking_price && <span className="body-S red-D">{error?.asking_price}</span>}
      </div>

       <div className="mt-6">
        <label className="dark-H head-4 mb-2 required:*:">
          Asking Cap Rate
        </label>
        <InputWithIcon
           icon={percentage}
          className="body-N"
          name="contact"
          type="number"
          placeholder="Write Here"
          value={formData?.asking_cap_rate}
          onChange={(e) => {
            handleChange(e.target.value, "asking_cap_rate");
          }}
          onWheel={(e) => e.target.blur()}
        />
        {error?.asking_cap_rate && <span className="body-S red-D">{error?.asking_cap_rate}</span>}
      </div>

       <div className="mt-6">
        <label className="dark-H head-4 mb-2 required:*:">
          Lease Expiration Date
        </label>
        <DatePicker
          className="body-N"
          dateFormat="MM/dd/yyyy"
          placeholderText="MM/DD/YYYY"
          minDate={new Date()}
          selected={formData.lease_expiration_date}
          onChange={(date) => {
            handleChange(date, "lease_expiration_date");
          }}
        />
        {error?.lease_expiration_date && <span className="body-S red-D">{error?.lease_expiration_date}</span>}
      </div>

       <div className="mt-6">
        <label className="dark-H head-4 mb-2 required:*:">
          Lease Type
        </label>
         <Select
            className="body-N"
            options={landlordOptions}
            placeholder={"Select Option"}
            value={landlordOptions?.find((option) => option?.value === formData.lease_type)}
            onChange={(option) => {
              handleChange(option?.value, "lease_type");
            }}
          />
        {error?.lease_type && <span className="body-S red-D">{error?.lease_type}</span>}
      </div>


      <div className="mt-6">
        <button type="submit" disabled={disable} className="save-button light-L head-5 green-bg-H">
          Save
        </button>
        <button type="button" onClick={handleClose} className="green-H ml-5">
          Cancel
        </button>
      </div>
    </form>
  );
};

export default AddExclusiveData;
